import type { Statement } from '@simplywallst/services/lib/endpoints/types/company/general/CompanyAPIStatements';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryFn } from './queryFn';
import type { StatementName } from './types';

/**
 * This hook returns the formatted statements for the given company,
 * Data comes from the statements API
 */
const useCompanyStatementsAPIFormatted = <
  StatementsMap = Record<StatementName, Statement | never>
>({
  canonicalURL,
}: {
  canonicalURL: string;
}): UseQueryResult<StatementsMap, unknown> => {
  const query = useQuery({
    queryKey: ['COMPANY_STATEMENTS_API', canonicalURL],
    queryFn,
    staleTime: 3600000,
    select: (data) => {
      if (!data) return {} as StatementsMap;
      return data.statements.data.reduce((prev, curr) => {
        prev[curr.name] = curr;
        return prev;
      }, {}) as StatementsMap;
    },
  });

  return query;
};
export default useCompanyStatementsAPIFormatted;
